var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.511,
    height: 33.32,
    viewBox: "0 0 20.511 33.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Kabaddi_Court_514719",
    "data-name": "noun_Kabaddi Court_514719",
    transform: "translate(28.509 -3.001) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    transform: "translate(3.001 7.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M3,1028.36H19.016v2.566H3Z",
    transform: "translate(-3.001 -1028.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M16.5,1028.36H32.519v2.566H16.5v-2.566Z",
    transform: "translate(0.801 -1028.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M3,1031.366h1.92v12.809H3v-12.809Z",
    transform: "translate(-3.001 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M5.5,1031.366h1.92v12.809H5.5Z",
    transform: "translate(-2.296 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M8,1031.366h9.612v12.809H8Z",
    transform: "translate(-1.594 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M16.5,1031.366h9.612v12.809H16.5v-12.809Z",
    transform: "translate(0.801 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M25,1031.366h1.93v12.809H25Z",
    transform: "translate(3.194 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M27.5,1031.366h1.92v12.809H27.5Z",
    transform: "translate(3.899 -1027.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M3,1042.364H19.016v2.563H3Z",
    transform: "translate(-3.001 -1024.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M16.5,1042.364H32.519v2.563H16.5v-2.563Z",
    transform: "translate(0.801 -1024.416)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldVertical);
export default __webpack_public_path__ + "static/media/field-vertical.6e0f32ba0bf983790a1bb373991b238c.svg";
export { ForwardRef as ReactComponent };